var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'pointer pa-1 text--caption',
    _vm.hover ? 'grey lighten-3' : '',
    _vm.value ? 'blue--text text--darken-2' : 'grey--text text--darken-4' ],on:{"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false},"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[(_vm.icon.length == 0)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }